import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home';
// 四大類別：放在上面引入代表沒不需要code splitting
import TheArtworks from '@/views/TheArtworks.vue';
import TheTemples from '@/views/TheTemples.vue';
import TheThemes from '@/views/TheThemes.vue';
import TheAlbums from '@/views/TheAlbums.vue';

// 其他頁面
import TheTagList from '@/views/TheTagList.vue';
import Friendlinks from '@/views/Friendlinks.vue';
import Sitemap from '@/views/Sitemap.vue';

// 會員功能頁
import MemberLogin from '@/views/MemberLogin.vue';
import MemberRegister from '@/views/MemberRegister.vue';
import MemberForgotPassword from '@/views/MemberForgotPassword.vue';
import MemberResetPassword from '@/views/MemberResetPassword.vue';

Vue.use(Router);

export const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    // 首頁
    {
      path: '/',
      component: Home,
      children: [
        // 首頁根目錄，預設的主視圖放所有子元件
        {
          path: '',
          components: {
            homepageMainView: () => import('@/views/HomepageAllChildren.vue'),
          },
        },

        // 當切換到 Google Calendar，切換主視圖，共用上方的元件
        {
          path: 'calendar',
          name: 'calendar',
          components: {
            homepageMainView: () => import('@/views/TheGoogleCalendar.vue'),
          },
        },
      ],
    },

    // 香科年首頁
    {
      path: '/festival-year',
      name: 'festivalYear',
      component: () => import('@/views/TheFestivalYearHomepage.vue'),
      meta: { isRenderingFestivalTheme: true },
      children: [],
    },
    // 香科年介紹列表
    {
      path: '/festival-year/festivals',
      name: 'festivalYearFestivalList',
      meta: { isRenderingFestivalTheme: true },
      component: () => import('@/views/FestivalYear/TheFestivals.vue'),
    },
    // 香科年介紹內文
    {
      path: '/festival-year/festival/:articleId',
      name: 'festivalYearFestival',
      meta: {
        isRenderingFestivalTheme: true,
        articleTemplate: 'activity',
      },
      component: () => import('@/views/FestivalYear/TheFestival.vue'),
    },
    // 藝陣與特展列表, 相關課程列表
    // {
    //   path: '/festival-year/skills',
    //   name: 'festivalYearSkillList',
    //   meta: { isRenderingFestivalTheme: true },
    //   component: () => import('@/views/FestivalYear/TheSkills.vue'),
    // },
    // 藝陣與特展內文, 相關課程內文
    // {
    //   path: '/festival-year/skills/:articleId',
    //   name: 'festivalYearSkill',
    //   meta: {
    //     isRenderingFestivalTheme: true,
    //     articleTemplate: 'activity',
    //   },
    //   component: () => import('@/views/FestivalYear/TheSkill.vue'),
    // },
    // 活動資訊列表
    {
      path: '/festival-year/infos',
      name: 'festivalYearInformationList',
      meta: { isRenderingFestivalTheme: true },
      component: () => import('@/views/FestivalYear/TheInformationList.vue'),
    },
    // 活動資訊內文
    {
      path: '/festival-year/info/:articleId',
      name: 'festivalYearInformation',
      meta: {
        isRenderingFestivalTheme: true,
        articleTemplate: 'information',
      },
      component: () => import('@/views/FestivalYear/TheInformation.vue'),
    },
    // 最新消息列表
    // {
    //   path: '/festival-year/news',
    //   name: 'festivalYearNewsList',
    //   meta: { isRenderingFestivalTheme: true },
    //   component: () => import('@/views/FestivalYear/TheNewsList.vue'),
    // },
    // 最新消息內文
    // {
    //   path: '/festival-year/news/:articleId',
    //   name: 'festivalYearNews',
    //   meta: {
    //     isRenderingFestivalTheme: true,
    //     articleTemplate: 'information',
    //   },
    //   component: () => import('@/views/FestivalYear/TheNews.vue'),
    // },
    // English 列表
    {
      path: '/festival-year/english',
      name: 'festivalYearEnglishList',
      meta: { isRenderingFestivalTheme: true },
      component: () => import('@/views/FestivalYear/TheEnglishList.vue'),
    },
    // English 內文
    {
      path: '/festival-year/english/:articleId',
      name: 'festivalYearEnglish',
      meta: {
        isRenderingFestivalTheme: true,
        articleTemplate: 'information',
      },
      component: () => import('@/views/FestivalYear/TheEnglish.vue'),
    },
    // 歷史回顧
    {
      path: '/festival-year/history',
      name: 'festivalYearHistory',
      meta: { isRenderingFestivalTheme: true },
      component: () => import('@/views/FestivalYear/TheHistory.vue'),
    },
    // 列表頁
    {
      path: '/artworks',
      name: 'artworks',
      component: TheArtworks,
    },
    {
      path: '/temples',
      name: 'temples',
      component: TheTemples,
    },
    {
      path: '/themes',
      name: 'themes',
      component: TheThemes,
    },
    {
      path: '/albums',
      name: 'albums',
      component: TheAlbums,
    },

    // 內頁
    {
      path: '/artwork/:articleId',
      name: 'artwork',
      component: () => import('@/views/TheArtwork.vue'),
    },
    {
      path: '/temple/:articleId',
      name: 'temple',
      component: () => import('@/views/TheTemple.vue'),
    },
    {
      path: '/theme/:articleId',
      name: 'theme',
      component: () => import('@/views/TheTheme.vue'),
    },
    {
      path: '/album/:articleId',
      name: 'album',
      component: () => import('@/views/TheAlbum.vue'),
    },

    // 首頁分類相關結果
    {
      path: '/feature/:featureId',
      name: 'feature',
      component: () => import('@/views/FeatureResults.vue'),
    },

    // 標籤頁
    {
      path: '/tags',
      name: 'tags',
      component: TheTagList,
    },

    // 標籤相關結果
    {
      path: '/tag/:tagId',
      name: 'tag',
      component: () => import('@/views/TagResults.vue'),
    },

    // 友善連結
    {
      path: '/links',
      name: 'links',
      component: Friendlinks,
    },
    // 網站導覽
    {
      path: '/sitemap',
      name: 'sitemap',
      component: Sitemap,
    },
    // 搜尋關鍵字結果
    {
      path: '/searchinput',
      name: 'searchInput',
      component: () => import('@/views/SearchInput.vue'),
    },

    // 搜尋關鍵字結果
    {
      path: '/search/:keyword',
      name: 'search',
      component: () => import('@/views/SearchResults.vue'),
    },
    {
      // 我的收藏頁
      path: '/favourite',
      name: 'favourite',
      component: () => import('../views/FavouriteResults.vue'),
    },

    // 會員功能
    {
      path: '/login',
      name: 'login',
      component: MemberLogin,
    },
    {
      path: '/register',
      name: 'register',
      component: MemberRegister,
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: MemberForgotPassword,
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: MemberResetPassword,
    },

    // 語言頁
    {
      path: '/english',
      name: 'english',
      component: () => import('@/views/TheEnglish.vue'),
    },

    // 標籤頁
    {
      path: '/japanese',
      name: 'japanese',
      component: () => import('@/views/TheJapanese.vue'),
    },

    // 404 not found
    // 必須置於 routes 最下方
    {
      path: '/404',
      name: 'PageNotFound',
      component: () => import('@/views/PageNotFound.vue'),
    },
    {
      path: '*',
      name: 'PageNotFoundForAll',
      component: () => import('@/views/PageNotFound.vue'),
    },
  ],

  scrollBehavior(to, from, savedPosition) {
    function getDeviceOffset() {
      const currentDeviceWidth = document.body.offsetWidth;

      console.log(currentDeviceWidth);

      switch (true) {
        case currentDeviceWidth <= 320: {
          //mobile
          return 30;
        }
        case currentDeviceWidth <= 768: {
          //tablet
          return 50;
        }
        case currentDeviceWidth <= 1024: {
          // tablet-horizontal
          return 120;
        }
        case currentDeviceWidth <= 1440:
        default: {
          // desktop
          return 180;
        }
      }
    }

    // if (savedPosition) {
    //   return savedPosition;
    // } else {
    //   const position = {};

    //   // scroll to anchor by returning the selector
    //   if (to.hash) {
    //     position.selector = to.hash;
    //     position.y = getDeviceOffset();

    //     // bypass #1number check
    //     if (/^#\d/.test(to.hash) || document.querySelector(to.hash)) {
    //       console.log("# position", position);
    //       return position;
    //     }

    //     // if the returned position is falsy or an empty object,
    //     // will retain current scroll position.
    //     // return false;
    //   }
    // }

    if (savedPosition) {
      return savedPosition;
    } else {
      const deviceOffset = getDeviceOffset();

      if (to.hash) {
        document.querySelector(to.hash).scrollIntoView();
        const top =
          to.path === '/'
            ? document.querySelector(to.hash).offsetTop - deviceOffset
            : document.querySelector(to.hash).offsetTop - 100;

        const element = document.querySelector(to.hash);
        element.focus();

        return window.scrollTo({
          top,
          behavior: 'smooth',
        });
      }

      return window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  },
});

router.beforeEach((to, from, next) => {
  const isFestivalYear = to.meta.isRenderingFestivalTheme;
  const hasFestivalYearClass = document.documentElement.classList.contains(
    'light'
  );

  if (isFestivalYear) {
    document.documentElement.classList.add('light');
  } else if (!isFestivalYear && hasFestivalYearClass) {
    document.documentElement.classList.remove('light');
  }

  // Reset focus at top when router changes
  // to get the focus on skip link
  document.body.setAttribute('tabindex', '-1');
  document.body.focus();
  document.body.removeAttribute('tabindex');

  next();
});

export default router;
